module.exports = __webpack_public_path__ + "media/images/default_pin-9dbf88df6c56a435c77b2a6e9688065a.svg";